<template>
    <div class="mens" v-if="list">
        <div class="box">
            <!-- <div class="item" v-if="Defot">
                <matchItem :class="{action: match_id == Defot.match_id}" @click.native="changMatch(Defot)" :data="Defot" />
            </div> -->
            <template v-for="zhi in list">
                <div class="item" v-for="is,index in zhi" :key="index">
                    <div class="navItem">
                        {{index}}
                    </div>
                    <template v-for="item,indx in is">
                        <matchItem :class="{action: match_id == item.match_id}" @click.native="changMatch(item)" :key="indx" :data="item" />
                    </template>
                </div>
            </template>
            
        </div>
    </div>
</template>

<script>
import matchItem from "../match/common/matchItem.vue"
import { matchTournamentSchedule, matchTournamentLive } from "../../api/api"
export default {
    name: "mens",
    props: ['match_id', 'homeName', 'awayName', 'status'],
    components: {
        matchItem
    },
    data () {
        return {
            list: null,
            timeMatch: null,
            Defot: null,
            i:0
        }
    },
    created () {
        this.getList().then(() => {
            this.initMatch()
        })
    },
    methods: {
        getDom () {
            let dom = document.querySelector(".action")
            let mens = document.querySelector(".mens")
            mens.scrollTop = dom.offsetTop - 78
        },
        initMatch () {
            // debugger
            let status = -1
            let Ongoing = []
            let NotStarted = []
            let complete = []
            // let arr = this.list['杯赛']
            // Object.keys(arr).forEach((item) => {
            //     arr[item].forEach((is) => {
            //         if (is.status == 2) {
            //             Ongoing.push(is)
            //         }
            //         if (is.status == 1) {
            //             NotStarted.push(is)
            //         }
            //         if (is.status == 3) {
            //             complete.push(is)
            //         }
            //     })
            // });
            let arr = this.list
            Object.keys(arr).forEach((inc) => {
                 Object.keys(arr[inc]).forEach((item) => {
                    arr[inc][item].forEach((is) => {
                        if (is.status == 2) {
                            Ongoing.push(is)
                        }
                        if (is.status == 1) {
                            NotStarted.push(is)
                        }
                        if (is.status == 3) {
                            complete.push(is)
                        }
                    })
                });
            })
           
            if (Ongoing.length > 0) {
                this.$emit("update:match_id",Ongoing[0].match_id)
                this.$emit("update:homeName",Ongoing[0].home_team.team_name)
                this.$emit("update:awayName",Ongoing[0].away_team.team_name)
                this.$emit("update:status",Ongoing[0].status)
            } else if (NotStarted.length > 0) {
                this.$emit("update:match_id",NotStarted[0].match_id)
                this.$emit("update:homeName",NotStarted[0].home_team.team_name)
                this.$emit("update:awayName",NotStarted[0].away_team.team_name)
                this.$emit("update:status",NotStarted[0].status)
            } else {
                this.$emit("update:match_id",complete[0].match_id)
                this.$emit("update:homeName",complete[0].home_team.team_name)
                this.$emit("update:awayName",complete[0].away_team.team_name)
                this.$emit("update:status",complete[0].status)
            }
            this.$nextTick(() => {
                this.getDom()
                if (this.status == 2) {
                    this.timeMatch = setInterval(() => {
                        this.TournamentLive()
                    },30000)
                }
                // Object.keys(arr).forEach((inc) => {
                //     Object.keys(arr[inc]).forEach((item) => {
                //         arr[inc][item].forEach((is,index) => {
                //             if (this.match_id == is.match_id) {
                //                 // this.Defot = is
                //                 this.$nextTick(() => {
                //                     item = is
                //                 })
                //             }
                //         })
                //     });
                // })
            })
            
        },
        async getList () {
            const params = {
                id: 262851
            }
            const res = await matchTournamentSchedule(params)
            if (res.code == 0) {
                this.list = res.data
            }
        },
        async TournamentLive () {
            const params = {
                r: parseInt(new Date().getTime() / 1000) 
            }
            const res = await matchTournamentLive(params)
            let listKong = res.data
            if (res.code == 0 && res.data) {
                let arr = this.list
                Object.keys(arr).forEach((inc) => {
                    Object.keys(arr[inc]).forEach((item) => {
                        arr[inc][item].forEach((is,index) => {
                            listKong.forEach((s) => {
                                if (s.match_id == is.match_id) {
                                    this.$nextTick(() => {
                                       this.$set(arr[inc][item],index,s)
                                    })
                                }
                            })
                        })
                    });
                })
                listKong.forEach((item) => {
                    if (this.Defot) {
                        if (this.Defot.match_id == item.match_id){
                            this.$nextTick(() => {
                                this.Defot = item
                            })
                        }
                    }
                })
            }
        },
        changMatch (item) {
            this.$emit("update:match_id",item.match_id)
            this.$emit("update:homeName",item.home_team.team_name)
            this.$emit("update:awayName",item.away_team.team_name)
            this.$emit("update:status",item.status)
        }
    }
}
</script>

<style lang="less">
.mens{
    width: 265px;
    height: 100%;
    overflow: scroll;
    margin-top: 5px;
    .box{
	    // height: 1223px;
        .item{
            // height: 528px;
            background: #FFFFFF;
            border: 1px solid #EEEEEE;
            border-radius: 4px;
            margin-bottom: 10px;
            .navItem{
                height: 38px;
                background: #EEEFF2;
                border: 1px solid #EEEEEE;
                border-radius: 4px;
                font-size: 18px;
                font-weight: 400;
                color: #333333;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                &::before{
                    content: '';
                    width: 6px;
                    height: 14px;
                    background: #AB1B23;
                    margin: 0 14px 0 12px;
                }
                position: sticky;
                top: 0;

            }
            .matchItem{
                &:nth-child(odd){
                    background: #F6F6F8
                }
            }
            cursor: pointer;
           .matchItem{
                border: 1px solid #fff;
                transition: background 0.3s;
                &:hover{
                    background: #EAF2FF;
                    border: 1px solid #558CE7;
                }
           }
           .action{
               background: #EAF2FF;
                border: 1px solid #558CE7;
           }
        }
    }
}
</style>